import anime from 'animejs/lib/anime.es.js'

function roundRect(ctx, x, y, width, height, radius) {
    ctx.beginPath()
    ctx.moveTo(x + radius, y)
    ctx.lineTo(x + width - radius, y)
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
    ctx.lineTo(x + width, y + height - radius)
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
    ctx.lineTo(x + radius, y + height)
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
    ctx.lineTo(x, y + radius)
    ctx.quadraticCurveTo(x, y, x + radius, y)
    ctx.closePath()
    ctx.fill()
    ctx.stroke()
}

let data = {
    fonts: {
        primary: "64px Open Sans",
        debug: "16px monaco",
    },
    colors: {
        green: "#7ce467"
    }
}

let state = {
    canvas: null,
    ctx: null,
    width: 0,
    height: 0,
    mouse: {
        x: 0,
        y: 0,
    },
    debug: {
        draw: false,
    }
}

function update() {
    let {ctx, width, height} = state

    ctx.clearRect(0, 0, width, height)

    // ctx.fillStyle = "rgba(255, 255, 255, 0.85)"
    ctx.fillStyle = "rgba(255, 255, 255, 1.0)"
    ctx.strokeStyle = "#232323"
    ctx.fillRect(0, 0, width, height)

    let x = 0
    let y = height / 2
    let t = (1 + Math.sin(performance.now() * 0.00125)) / 2

    ctx.font = data.fonts.primary

    let strings = [
        "A place to",
        "bring employees together",
        "& help them succeed"
    ]

    for (let i = 0; i < strings.length; ++i) {
        let pi = Math.PI
        let time = performance.now() * 0.000125
        let lh = 64 * 0.25

        let r = ctx.measureText(strings[i])
        let w = r.width
        let h = r.height
        let x = ((1 + Math.sin(pi * (i / strings.length) + time)) / 2) * (width - w)
        let y = lh * i + 64 * (i + 1)

        ctx.fillStyle = "rgba(255, 0, 0, 0.25)"
        ctx.fillRect(x, y - 64 + lh, w, 64)
        ctx.fillStyle = "#232323"
        ctx.fillText(strings[i], x, y)
    }

    ctx.fillStyle = data.colors.green
    ctx.strokeStyle = "transparent"
    ctx.save()
    ctx.translate(120, height - 50)
    ctx.rotate(Math.sin(performance.now() * 0.00125) * Math.PI * 0.0125)
    roundRect(ctx, -110, -25, 220, 50, 8)
    ctx.restore()

    if (state.debug.draw) {
        ctx.fillStyle = "rgba(0, 0, 255, 0.75)"
        ctx.strokeStyle = "rgba(0, 0, 255, 0.75)"

        ctx.font = data.fonts.debug
        ctx.fillText("mouse x, y: " + state.mouse.x + "," + state.mouse.y, 8, 8 + 16)

        ctx.strokeRect(1, 1, width - 1, height - 1)

        ctx.beginPath()

        ctx.moveTo(width * 0.50, 0)
        ctx.lineTo(width * 0.50, height)

        ctx.moveTo(width * 0.25, 0)
        ctx.lineTo(width * 0.25, height)

        ctx.moveTo(width * 0.75, 0)
        ctx.lineTo(width * 0.75, height)

        ctx.moveTo(0, height * 0.50)
        ctx.lineTo(width, height * 0.50)

        ctx.stroke()
    }

    requestAnimationFrame(update)
}

function init() {
    let block = document.querySelector('.js-TextEffects')

    if (!block) {
        return;
    }

    let dpr = window.devicePixelRatio  || 1
    block.style.position = "relative"

    let canvas = document.createElement('canvas')

    canvas.style.position = "absolute"
    canvas.style.left = "0"
    canvas.style.top = "0"
    canvas.style.width = "100%"
    canvas.style.height = "100%"

    block.appendChild(canvas)

    let rect = canvas.getBoundingClientRect()
    let width = rect.width
    let height = rect.height

    canvas.width = width * dpr
    canvas.height = height * dpr

    let ctx = canvas.getContext('2d')
    ctx.scale(dpr, dpr)
    ctx.font = data.fonts.primary

    state.canvas = canvas
    state.ctx = ctx
    state.width = width
    state.height = height

    canvas.addEventListener('mousemove', function(event) {
        state.mouse.x = event.offsetX
        state.mouse.y = event.offsetY
    })

    window.addEventListener('keyup', function(event) {
        if (event.code == "Backquote") {
            state.debug.draw = !state.debug.draw
        }
    })

    window.addEventListener('keydown', function(event) {

    })

    update()
}

init()

let timeline = anime.timeline({
    loop: true,
    easing: 'cubicBezier(0.335, 0, 0.335, 1)',
    duration: 1000
})
